































import { Vue, Prop, Component } from "vue-property-decorator";
import { Folder as IFolder } from "@/api/models/folder";
import MiniModal from "@/components/form/MiniModal.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({ components: { CustomButton, MiniModal } })
export default class FileManagerTableItemFolder extends Vue {
  @Prop() item!: IFolder;
  modalToRemove: boolean = false;
  nameEdited: boolean = false;
  data() {
    return {};
  }

  selectFolder() {
    this.$emit("selectFolder", this.item);
  }

  deleteFolder() {
    this.$emit("deleteFolder", this.item);
  }
}
